import { render } from "./BenefitsCard.vue?vue&type=template&id=1f524090"
import script from "./BenefitsCard.vue?vue&type=script&lang=js"
export * from "./BenefitsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__